import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type TServiceCentersState = {
  servicePage: 'services' | 'address'
  servicePageTab: 'map' | 'list'
  serviceListSearchText: string
}
const initialState: TServiceCentersState = {
  servicePage: 'services',
  servicePageTab: 'map',
  serviceListSearchText: '',
}
const ServiceCentersSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    // переключение между страницами
    setServicePage: (state, action: PayloadAction<'services' | 'address'>) => {
      state.servicePage = action.payload
    },
    // переключение между табами на странице сц
    setServiceTab: (state, action: PayloadAction<'map' | 'list'>) => {
      state.servicePageTab = action.payload
    },
    // текст для поиска сц
    setServiceListSearchText: (state, action: PayloadAction<string>) => {
      state.serviceListSearchText = action.payload.toLowerCase()
    },
  },
})

export const { actions, reducer } = ServiceCentersSlice
export const { setServiceListSearchText } = actions
